import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import Input from "../../../../common/Input";
import ModalInstructions from "../../../../primer/POPUP-COMPONENTS/Instructions";
import EditableTable from "../../../../primer/Editable-Table";
import {
    checkPermission,
    DISABLED_PRODUCT_CATEGORIES,
    getOptionsByData,
    isEmpty,
    quickClone
} from "../../../../../_helpers/commonFunctions";
import {
    resetTempNewDefaultProperties, setNewProductsCategoryMyData,
    setTempNewDefaultProperties
} from "../../../../../_reducers/DataPanel/Products/productCategorySlice";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import getMyData, {
    getInvoiceTypesOptions,
    getMyDataRowTypes,
    getVatExpenseClassificationType
} from "../../../../../_helpers/sharedmydata";
import axios from "axios";
import Dropdown from "../../../../primer/Dropdown";
import BetterCheckBox from "../../../../common/BetterCheckBox";
import {useTranslation} from "../../../../../hooks/useTranslation";

const CategoryModal = ({modalType, categoryType, defaultObject, show, setShow, callbackFunction}) => { // Manages new/edit category/subCategory
    // modalType = new / edit
    // categoryType = category / subCategory
    const dispatch = useDispatch();
    const PRODUCTS_CATEGORY = useSelector((state) => state.PRODUCTS_CATEGORY);
    const SETTINGS = useSelector(state => state.SETTINGS);
    const company = useSelector(state => state.COMPANY_DATA.company);
    const {t} = useTranslation();
    const [obj, setObj] = useState({});
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const myDataRowTypes = getMyDataRowTypes();
    const invoiceTypes = getInvoiceTypesOptions();
    const vatExpenseTypes = getVatExpenseClassificationType();

    const [loadingApplyToAll, setLoadingApplyToAll] = useState(false);
    const [showApplyToAll, setShowApplyToAll] = useState(false);
    const [showSetMyDataToAll, setShowSetMyDataToAll] = useState(false);
    const [showAddMyDataToAll, setShowAddMyDataToAll] = useState(false);

    const [incrKey, setIncrKey] = useState(0);
    const [incrKey2, setIncrKey2] = useState(0);

    const measurementUnits = getMyData({type: 'mu'});
    const vatTaxes = [
        {value: "", label: t("Null")},
        ...getMyData({type: 'vat'})
    ];
    const zeroVatReason = getMyData({type: 'zerovatreason'});

    const pMDDSettings = SETTINGS.primerMyDataData;
    const otherTaxes = [
        {value: "", label: t("Null")},
        ...getOptionsByData(pMDDSettings?.otherTaxes ? pMDDSettings.otherTaxes : SETTINGS.otherHoldTaxes, 'code', 'name')
    ];
    const taxesWithhold = [
        {value: "", label: t("Null")},
        ...getOptionsByData(pMDDSettings?.withHoldTaxes ? pMDDSettings.withHoldTaxes : SETTINGS.withHoldTaxes, 'code', 'name')
    ];
    const taxesStamp = [
        {value: "", label: t("Null")},
        ...getOptionsByData(pMDDSettings?.stamp ? pMDDSettings.stamp : SETTINGS.stamp, 'code', 'name'),
    ];
    const taxesFees = [
        {value: "", label: t("Null")},
        ...getOptionsByData(pMDDSettings?.fees ? pMDDSettings.fees : SETTINGS.fees, 'code', 'name'),
    ];

    useEffect(() => {
        if (show) {
            setObj(defaultObject);
        } else {
            setObj({});
        }
    }, [show]);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [obj?.defaultProperties])

    useEffect(() => {
        setIncrKey2(incrKey2 + 1);
    }, [obj?.mydata])

    const propertiesInstructions = {
        title: "Οδηγίες Εισαγωγής Ιδιοτήτων",
        content: "<div>Εισάγετε ιδιότητες ειδών χωρίζοντάς τις τιμές με κόμμα (,).<br><br>Καθορίστε αυξομειώσεις τιμής σε συγκεκριμένες παραλλαγές με ανω-κάτω τελεία(:)<br><br><u>Παράδειγμα</u><br>Όνομα Ιδιότητας: Χρώμα<br>Τιμές Ιδιότητας: μαύρο,κόκκινο:3,κίτρινο:-3,μπλε</div>"
    }

    const propertiesColumns = [
        {
            name: 'Όνομα Ιδιότητας',
            field: 'name',
            editable: true,
            width: "20%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: 'Τιμές Ιδιότητας',
            field: 'values',
            editable: true,
            width: "80%",
            inputType: {
                type: 'text',
            }
        },
    ];

    const productsColumns = [
        {
            name: t('ProductsNewGeneral.table.rowType'),
            field: "rowType",
            width: "10%",
            editable: true,
            inputType: {
                type: 'select',
                options: myDataRowTypes
            }
        },
        {
            name: t('ProductsSettings.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            width: "30%",
            inputType: {
                type: 'select',
                options: invoiceTypes,
            }
        },
        {
            name: t('ProductsSettings.table.category'),
            field: "category",
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        {
            name: t('ProductsSettings.table.type'),
            field: 'type',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        {
            name: t('ProductsNewGeneral.table.vatExpenseType'),
            field: 'vatExpenseType',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: vatExpenseTypes,
            }
        }
    ];

    const renderTitle = () => {
        if (modalType === "new") {
            if (categoryType === "category") {
                return "Νέα Κατηγορία Ειδών";
            } else if (categoryType === "subCategory") {
                return "Νέα Υποκατηγορία Ειδών";
            }
        } else if (modalType === "edit") {
            if (categoryType === "category") {
                return "Επεξεργασία Κατηγορίας";
            } else if (categoryType === "subCategory") {
                return "Επεξεργασία Υποκατηγορίας";
            }
        }
        return "";
    }

    const handleOnChange = (e, type, name) => {
        let prepChanges = {};
        if (type === "cb") {
            prepChanges[name] = e.target.checked === true ? "active" : "inactive";
        } else if (type === "input") {
            prepChanges[name] = e.target.value;
            if (name === "maskCode") {
                const prefix = String(e.target.value).split("-")[0];
                prepChanges.mask = e.target.value;
                prepChanges.maskCodePrefix = prefix;
            }
        } else if (type === "dd") {
            prepChanges[name] = e.value;
        } else if (type === "taxes-dd") {
            prepChanges["taxes"] = {...obj.taxes};
            prepChanges["taxes"][name] = e.value;
        }
        setObj({...obj, ...prepChanges});
    }

    const propertiesActions = {
        insert: (e, data) => {
            if (isEmpty(data.value)) return;

            let tempNewProperty = structuredClone(PRODUCTS_CATEGORY.tempNewDefaultProperties);
            tempNewProperty[data.field] = data.value;
            if (isEmpty(tempNewProperty.name) || isEmpty(tempNewProperty.values)) {
                dispatch(setTempNewDefaultProperties(tempNewProperty));
            } else {
                let defaultProperties = Object.assign([], obj.defaultProperties);
                if (defaultProperties.filter((prop) => prop.name === tempNewProperty.name).length !== 0) return toast.error("Διπλότυπη Ιδιότητα.");
                defaultProperties.push(tempNewProperty);
                dispatch(resetTempNewDefaultProperties());
                setObj({...obj, defaultProperties: defaultProperties});
            }
        },
        update: (data, id, rowIndex) => {
            let defaultProperties = structuredClone(obj.defaultProperties);
            if (defaultProperties.filter((prop, index) => index !== rowIndex && prop.name === data.name).length !== 0) return toast.error("Διπλότυπη Ιδιότητα.");
            defaultProperties[rowIndex] = {...defaultProperties[rowIndex], ...data};
            setObj({...obj, defaultProperties: defaultProperties});
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            let defaultProperties = structuredClone(obj.defaultProperties);
            defaultProperties.splice(rowIndex, 1);
            setObj({...obj, defaultProperties: defaultProperties});
        }
    }

    const parentMydataActions = {
        insert: (e, data) => {
            let tempPcMyData = Object.assign({}, PRODUCTS_CATEGORY.newProductsCategoryMyData);
            if (e.key !== "Enter") {
                tempPcMyData[data.field] = data.value;
                dispatch(setNewProductsCategoryMyData(tempPcMyData)); // Update redux my data values
            }

            // If validated fields done add new row
            if (tempPcMyData.rowType !== '' || tempPcMyData.invoiceType !== '' || tempPcMyData.category !== '' || tempPcMyData.type !== '') {
                let updateNewPcMydata = Object.assign({}, PRODUCTS_CATEGORY.newProductsCategoryMyData);
                updateNewPcMydata.id = obj.mydata.length + 1;
                if (tempPcMyData.type) updateNewPcMydata.type = tempPcMyData.type;
                if (tempPcMyData.rowType) updateNewPcMydata.rowType = tempPcMyData.rowType;
                if (tempPcMyData.invoiceType) updateNewPcMydata.invoiceType = tempPcMyData.invoiceType;
                if (tempPcMyData.category) updateNewPcMydata.category = tempPcMyData.category;
                setObj({...obj, mydata: [...obj.mydata, updateNewPcMydata]});
                dispatch(setNewProductsCategoryMyData(PRODUCTS_CATEGORY.newProductsCategoryMyDataInitialValue)); // Reset new category mydata
            }
            // Add on press enter
            if (e.key === "Enter" && data.field !== 'add') {
                if (data.field === 'rowType' && data.value === '') {
                    toast.error("My Data Row Type should not be empty.");
                } else {
                    let updateNewPcMydata = Object.assign({}, PRODUCTS_CATEGORY.newProductsCategoryMyData);
                    if (updateNewPcMydata.field === 'rowType' && updateNewPcMydata.value === '') {
                        toast.error("My Data Row Type should not be empty.");
                    } else {
                        updateNewPcMydata.id = obj.mydata.length + 1;
                        updateNewPcMydata.rowType = data.value;
                        setObj({...obj, mydata: [...obj.mydata, updateNewPcMydata]});
                        dispatch(setNewProductsCategoryMyData(PRODUCTS_CATEGORY.newProductsCategoryMyDataInitialValue)); // Reset new category mydata
                    }
                }
            }
        },
        update: (data, id, rowIndex) => {
            if (data.rowType && data.rowType === '') {
                toast.error("Row Type is mandatory field.");
            } else {
                const clone = quickClone(obj.mydata);
                clone[rowIndex] = {...clone[rowIndex], ...data};
                if (data.invoiceType) {
                    clone[rowIndex].category = "";
                    clone[rowIndex].type = "";
                    clone[rowIndex].vatExpenseType = "";
                } else if (data.category) {
                    clone[rowIndex].type = "";
                    clone[rowIndex].vatExpenseType = "";
                } else if (data.type) {
                    clone[rowIndex].vatExpenseType = "";
                }
                setObj({...obj, mydata: clone});
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            const clone = quickClone(obj.mydata);
            clone.splice(rowIndex, 1);
            setObj({...obj, mydata: clone});
        }
    }

    const handleApplyToAll = () => {
        setLoadingApplyToAll(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/category/apply-accounting-settings-to-all", {
            company: company.id,
            category: categoryType === "category" ? obj._id : undefined,
            subCategory: categoryType === "subCategory" ? obj._id : undefined,
            accountingCode: obj?.accountingCode ? obj.accountingCode : "",
            netAmountAccountingCode: obj?.netAmountAccountingCode ? obj.netAmountAccountingCode : "",
            vatAccountingCode: obj?.vatAccountingCode ? obj.vatAccountingCode : "",
            taxAccountCode: obj?.taxAccountCode ? obj.taxAccountCode : "",
            accountingCodeSales: obj?.accountingCodeSales ? obj.accountingCodeSales : "",
            netAmountAccountingCodeSales: obj?.netAmountAccountingCodeSales ? obj.netAmountAccountingCodeSales : "",
            vatAccountingCodeSales: obj?.vatAccountingCodeSales ? obj.vatAccountingCodeSales : "",
            taxAccountCodeSales: obj?.taxAccountCodeSales ? obj.taxAccountCodeSales : "",
            accountingCodeBuys: obj?.accountingCodeBuys ? obj.accountingCodeBuys : "",
            netAmountAccountingCodeBuys: obj?.netAmountAccountingCodeBuys ? obj.netAmountAccountingCodeBuys : "",
            vatAccountingCodeBuys: obj?.vatAccountingCodeBuys ? obj.vatAccountingCodeBuys : "",
            taxAccountCodeBuys: obj?.taxAccountCodeBuys ? obj.taxAccountCodeBuys : "",
        }, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            setLoadingApplyToAll(false);
            if (res.data.status === "200") {
                toast.success("Η διαδικασία ολοκληρώθηκε επιτυχώς.");
                setShowApplyToAll(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingApplyToAll(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }

    const handleSaveSetMyDataToAll = () => {
        setLoadingApplyToAll(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/category/set-category-mydata-to-all", {
            company: company.id,
            category: categoryType === "category" ? obj._id : undefined,
            subCategory: categoryType === "subCategory" ? obj._id : undefined,
            mydata: obj.mydata,
        }, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            setLoadingApplyToAll(false);
            if (res.data.status === "200") {
                toast.success("Η διαδικασία ολοκληρώθηκε επιτυχώς.");
                setShowSetMyDataToAll(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingApplyToAll(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }

    const handleSaveAddMyDataToAll = () => {
        setLoadingApplyToAll(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/category/add-category-mydata-to-all", {
            company: company.id,
            category: categoryType === "category" ? obj._id : undefined,
            subCategory: categoryType === "subCategory" ? obj._id : undefined,
            mydata: obj.mydata,
        }, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            setLoadingApplyToAll(false);
            if (res.data.status === "200") {
                toast.success("Η διαδικασία ολοκληρώθηκε επιτυχώς.");
                setShowAddMyDataToAll(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingApplyToAll(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>{renderTitle()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(show && Object.keys(defaultObject).length > 0) && (
                        <React.Fragment>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Input
                                        name={"title"}
                                        label={`Τίτλος ${categoryType === "category" ? "κατηγορίας" : "υποκατηγορίας"}`}
                                        value={obj.title}
                                        required={true}
                                        autoComplete={"off"}
                                        disabled={DISABLED_PRODUCT_CATEGORIES.includes(obj.title)}
                                        onChange={(e) => handleOnChange(e, "input", "title")}
                                        onBlur={(e) => {
                                            let prepChanges = {};
                                            if (isEmpty(obj.maskCode) && e.target.value) {
                                                const prefix = String(e.target.value).slice(0, 4);
                                                prepChanges.mask = `${prefix}-****`;
                                                prepChanges.maskCode = `${prefix}-****`;
                                                prepChanges.maskCodePrefix = prefix;
                                            }
                                            setObj({...obj, ...prepChanges});
                                        }}
                                    />
                                </Col>
                                {categoryType === "category" && (
                                    <Col md={3}>
                                        <Input
                                            name={"maskCode"}
                                            label={"Πρόθεμα"}
                                            value={obj.maskCode}
                                            autoComplete={"off"}
                                            allowSpecialCharacters={true}
                                            onChange={(e) => handleOnChange(e, "input", "maskCode")}
                                        />
                                    </Col>
                                )}
                            </Row>

                            {checkPermission("products-products/new-variants-write", permissionsData) === true && (
                                <Row className={"mb-2"}>
                                    <Col md={12}>
                                        <div className="text-muted mb-2 d-flex align-items-center">
                                            <i>{t("ProductVariants.productProperties")}</i>
                                            <div className="ml-2">
                                                <ModalInstructions data={propertiesInstructions}/>
                                            </div>
                                        </div>
                                        <EditableTable
                                            tableName="Default Category Properties" // Do not change name
                                            key={incrKey}
                                            onUpdate={propertiesActions}
                                            allowActions={true}
                                            allowInsertRow={true}
                                            columns={propertiesColumns}
                                            data={obj?.defaultProperties || []}
                                            enableNewRowCheckbox={true}
                                        />
                                    </Col>
                                </Row>
                            )}
                            <Row className={"mb-2"}>
                                <Col md={12}>
                                    <div className="text-muted mb-1"><i>{t('ProductsSettings.proposedMyDataValue')}</i></div>
                                    <EditableTable
                                        tableName="Product Category My Data" // Do not change name
                                        key={incrKey2}
                                        onUpdate={parentMydataActions}
                                        allowActions={true}
                                        allowInsertRow={true}
                                        columns={productsColumns}
                                        data={obj.mydata}
                                        enableNewRowCheckbox={true}
                                    />
                                    {modalType === "edit" && (
                                        <React.Fragment>
                                            <Button size={"sm"} className={"mr-2"} onClick={() => setShowSetMyDataToAll(true)}>Μαζική αντικατάσταση πίνακα MyData σε όλα τα είδη</Button>
                                            <Button size={"sm"} onClick={() => setShowAddMyDataToAll(true)}>Μαζική προσθήκη γραμμών πίνακα MyData σε όλα τα είδη</Button>
                                        </React.Fragment>
                                    )}
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={12}>
                                    <div className="text-muted"><i>{t('ProductsSettings.taxes')}</i></div>
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        name={"measurementUnit"}
                                        label={t('ProductsSettings.measurementUnit')}
                                        key={Math.random()}
                                        defaultValue={measurementUnits.find((el) => el.value === obj.measurementUnit)}
                                        options={measurementUnits}
                                        onChange={(e) => handleOnChange(e, 'dd', 'measurementUnit')}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        name={"vat"}
                                        label={t('ProductsSettings.vat%')}
                                        key={Math.random()}
                                        defaultValue={vatTaxes.find((el) => el.value === obj.taxes?.vat)}
                                        options={vatTaxes}
                                        onChange={(e) => handleOnChange(e, 'taxes-dd', 'vat')}
                                    />
                                </Col>
                                {String(obj.taxes?.vat) === "0" && (
                                    <Col md={3}>
                                        <Dropdown
                                            name={"vatreason"}
                                            label={t('ProductsSettings.0%vatReason')}
                                            key={Math.random()}
                                            defaultValue={zeroVatReason.find((el) => el.value === obj.taxes?.vatreason)}
                                            options={zeroVatReason}
                                            onChange={(e) => handleOnChange(e, 'taxes-dd', 'vatreason')}
                                        />
                                    </Col>
                                )}
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Dropdown
                                        name={"othertaxes"}
                                        label={t('ProductsSettings.otherTaxes')}
                                        key={Math.random()}
                                        defaultValue={otherTaxes.find((el) => el.value === obj.taxes?.othertaxes)}
                                        options={otherTaxes}
                                        onChange={(e) => handleOnChange(e, 'taxes-dd', 'othertaxes')}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        name={"witholdtaxes"}
                                        label={t('ProductsSettings.withHoldTaxes')}
                                        key={Math.random()}
                                        defaultValue={taxesWithhold.find((el) => el.value === obj.taxes?.witholdtaxes)}
                                        options={taxesWithhold}
                                        onChange={(e) => handleOnChange(e, 'taxes-dd', 'witholdtaxes')}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        name={"stamp"}
                                        label={t('ProductsSettings.stamp')}
                                        key={Math.random()}
                                        defaultValue={taxesStamp.find((el) => el.value === obj.taxes?.stamp)}
                                        options={taxesStamp}
                                        onChange={(e) => handleOnChange(e, 'taxes-dd', 'stamp')}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        name={"fees"}
                                        label={t('ProductsSettings.fees')}
                                        key={Math.random()}
                                        defaultValue={taxesFees.find((el) => el.value === obj.taxes?.fees)}
                                        options={taxesFees}
                                        onChange={(e) => handleOnChange(e, 'taxes-dd', 'fees')}
                                    />
                                </Col>
                            </Row>

                            {checkPermission("products-products/new-accounting-write", permissionsData) && (
                                <React.Fragment>
                                    <hr/>
                                    <p className="text-muted"><i>Λογιστική</i></p>
                                    <Row>
                                        <Col md={4}>
                                            <Input
                                                name={"accountingCode"}
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                                                label="Πρόθεμα Κωδικού Λογαριασμού"
                                                value={obj.accountingCode ? obj.accountingCode : ""}
                                                autoComplete={"off"}
                                                onChange={(e) => handleOnChange(e, "input", "accountingCode")}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <BetterCheckBox
                                                name={"accountingNonDeductibleVAT"}
                                                className={"mt-3"}
                                                text={"Μη Εκπιπτόμενος Φ.Π.Α."}
                                                checked={obj.accountingNonDeductibleVAT === "active"}
                                                onChange={(e) => handleOnChange(e, "cb", "accountingNonDeductibleVAT")}
                                            />
                                        </Col>
                                    </Row>
                                    <div className="text-muted mb-2"><i>Παράκαμψη Λογιστικής Γέφυρας</i></div>
                                    <Row>
                                        <Col md={4}>
                                            <Input
                                                name={"netAmountAccountingCode"}
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Κωδικό Λογαριασμού Καθαρής Αξίας"
                                                label="Κωδικός Λογαριασμού Καθαρής Αξίας"
                                                value={obj.netAmountAccountingCode ? obj.netAmountAccountingCode : ""}
                                                autoComplete={"off"}
                                                onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCode")}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <Input
                                                name={"vatAccountingCode"}
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Κωδικό Λογαριασμού ΦΠΑ"
                                                label="Κωδικός Λογαριασμού ΦΠΑ"
                                                value={obj.vatAccountingCode ? obj.vatAccountingCode : ""}
                                                autoComplete={"off"}
                                                onChange={(e) => handleOnChange(e, "input", "vatAccountingCode")}
                                            />
                                        </Col>
                                        <Col md={4}>
                                            <Input
                                                name={"taxAccountCode"}
                                                className={"mb-3"}
                                                charLimit={20}
                                                placeholder={"Εισάγετε Κωδικό Λογαριασμού Φόρου"}
                                                label={"Κωδικός λογαριασμού Φόρου"}
                                                value={obj.taxAccountCode ? obj.taxAccountCode : ""}
                                                autoComplete={"off"}
                                                onChange={(e) => handleOnChange(e, "input", "taxAccountCode")}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Πωλήσεις</i></div>
                                        <Col xs="12" md="3">
                                            <Input
                                                name="accountingCodeSales"
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                                                label="Πρόθεμα Κωδικού Λογαριασμού"
                                                value={obj.accountingCodeSales ? obj.accountingCodeSales : ""}
                                                onChange={(e) => handleOnChange(e, "input", "accountingCodeSales")}
                                            />
                                        </Col>
                                        <Col xs="12" md="3">
                                            <Input
                                                name="netAmountAccountingCodeSales"
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης Καθαρής Αξίας"
                                                label="Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"
                                                value={obj.netAmountAccountingCodeSales ? obj.netAmountAccountingCodeSales : ""}
                                                onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCodeSales")}
                                            />
                                        </Col>
                                        <Col xs="12" md="3">
                                            <Input
                                                name="vatAccountingCodeSales"
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης ΦΠΑ"
                                                label="Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"
                                                value={obj.vatAccountingCodeSales ? obj.vatAccountingCodeSales : ""}
                                                onChange={(e) => handleOnChange(e, "input", "vatAccountingCodeSales")}
                                            />
                                        </Col>
                                        <Col xs="12" md="3">
                                            <Input
                                                name={"taxAccountCodeSales"}
                                                className={"mb-3"}
                                                charLimit={20}
                                                placeholder={"Εισάγετε Κωδικό Λογαριασμού Παράκαμψης Φόρου"}
                                                label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                                                value={obj.taxAccountCodeSales ? obj.taxAccountCodeSales : ""}
                                                onChange={(e) => handleOnChange(e, "input", "taxAccountCodeSales")}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Αγορές</i></div>
                                        <Col xs="12" md="3">
                                            <Input
                                                name="accountingCodeBuys"
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                                                label="Πρόθεμα Κωδικού Λογαριασμού"
                                                value={obj.accountingCodeBuys ? obj.accountingCodeBuys : ""}
                                                onChange={(e) => handleOnChange(e, "input", "accountingCodeBuys")}
                                            />
                                        </Col>
                                        <Col xs="12" md="3">
                                            <Input
                                                name="netAmountAccountingCodeBuys"
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης Καθαρής Αξίας"
                                                label="Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"
                                                value={obj.netAmountAccountingCodeBuys ? obj.netAmountAccountingCodeBuys : ""}
                                                onChange={(e) => handleOnChange(e, "input", "netAmountAccountingCodeBuys")}
                                            />
                                        </Col>
                                        <Col xs="12" md="3">
                                            <Input
                                                name="vatAccountingCodeBuys"
                                                className="mb-3"
                                                charLimit={20}
                                                placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης ΦΠΑ"
                                                label="Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"
                                                value={obj.vatAccountingCodeBuys ? obj.vatAccountingCodeBuys : ""}
                                                onChange={(e) => handleOnChange(e, "input", "vatAccountingCodeBuys")}
                                            />
                                        </Col>
                                        <Col xs="12" md="3">
                                            <Input
                                                name={"taxAccountCodeBuys"}
                                                className={"mb-3"}
                                                charLimit={20}
                                                placeholder={"Εισάγετε Κωδικό Λογαριασμού Παράκαμψης Φόρου"}
                                                label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                                                value={obj.taxAccountCodeBuys ? obj.taxAccountCodeBuys : ""}
                                                onChange={(e) => handleOnChange(e, "input", "taxAccountCodeBuys")}
                                            />
                                        </Col>
                                    </Row>
                                    {modalType === "edit" && (
                                        <Row>
                                            <Col md={4}>
                                                <Button onClick={() => setShowApplyToAll(true)}>Εφαρμογή Λογιστικής σε όλα τα είδη αυτής της κατηγορίας</Button>
                                            </Col>
                                        </Row>
                                    )}
                                </React.Fragment>
                            )}

                            <Modal backdrop={"static"} show={showApplyToAll} onHide={() => setShowApplyToAll(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Εφαρμογή Λογιστικής σε όλα τα είδη</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <strong>Αποθηκεύστε τις ρυθμίσεις πρωτού ξεκινήσετε αυτήν την διαδικασία.</strong><br/>
                                    Είσαστε σίγουροι ότι θέλετε να εφαρμόσετε τις τωρινές ρυθμίσεις λογιστικής σε όλα τα είδη της
                                    {categoryType === "category" ? " κατηγορίας" : " υποκατηγορίας"} {obj.title};<br/>
                                    Συγκεκριμένα θα τοποθετηθεί:<br/>
                                    - Πρόθεμα Κωδικού λογαριασμού: {obj?.accountingCode ? obj.accountingCode : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης καθαρής αξίας: {obj?.netAmountAccountingCode ? obj.netAmountAccountingCode : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης ΦΠΑ: {obj?.vatAccountingCode ? obj.vatAccountingCode : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης Φόρου: {obj?.taxAccountCode ? obj.taxAccountCode : "Κενό"}<br/>
                                    - Πρόθεμα Κωδικού λογαριασμού για Πωλήσεις: {obj?.accountingCodeSales ? obj.accountingCodeSales : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης καθαρής αξίας για Πωλήσεις: {obj?.netAmountAccountingCodeSales ? obj.netAmountAccountingCodeSales : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης ΦΠΑ για Πωλήσεις: {obj?.vatAccountingCodeSales ? obj.vatAccountingCodeSales : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης Φόρου για Πωλήσεις: {obj?.taxAccountCodeSales ? obj.taxAccountCodeSales : "Κενό"}<br/>
                                    - Πρόθεμα Κωδικού λογαριασμού για Αγορές: {obj?.accountingCodeBuys ? obj.accountingCodeBuys : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης καθαρής αξίας για Αγορές: {obj?.netAmountAccountingCodeBuys ? obj.netAmountAccountingCodeBuys : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης ΦΠΑ για Αγορές: {obj?.vatAccountingCodeBuys ? obj.vatAccountingCodeBuys : "Κενό"}<br/>
                                    - Πρόθεμα Λογαριασμού παράκαμψης Φόρου για Αγορές: {obj?.taxAccountCodeBuys ? obj.taxAccountCodeBuys : "Κενό"}<br/>
                                    Η διαδικασία μπορεί να πάρει λίγο χρόνο.
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="outline-primary" onClick={() => setShowApplyToAll(false)}>Όχι, κλείσιμο</Button>
                                    <Button variant="primary" onClick={() => handleApplyToAll()} disabled={loadingApplyToAll}>Ναι,
                                        εφαρμογή σε όλα {loadingApplyToAll && <Spinner animation="border" variant="dark"/>}</Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showSetMyDataToAll} onHide={() => setShowSetMyDataToAll(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Αντικατάσταση γραμμών My Data</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Είσαστε σίγουροι ότι θέλετε να <u>αντικαταστήσετε</u> τις γραμμές MyData των ειδών που ανήκουν στην παρούσα {categoryType === "category" ? "κατηγορία " : "υποκατηγορία "}
                                    με τις γραμμές MyData που υπάρχουν αυτήν την στιγμή στην {categoryType === "category" ? "κατηγορία" : "υποκατηγορία"};
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" onClick={() => handleSaveSetMyDataToAll()} disabled={loadingApplyToAll}>
                                        Ναι, αντικατάσταση {loadingApplyToAll && <Spinner size={"sm"} animation="border" variant="dark"/>}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showAddMyDataToAll} onHide={() => setShowAddMyDataToAll(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Προσθήκη γραμμών My Data</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Είσαστε σίγουροι ότι θέλετε να <u>προσθέσετε</u> στις γραμμές MyData των ειδών που ανήκουν στην παρούσα {categoryType === "category" ? "κατηγορία " : "υποκατηγορία "},
                                    τις γραμμές που δεν υπάρχουν αλλά υπάρχουν στην παρούσα {categoryType === "category" ? "κατηγορία" : "υποκατηγορία "};
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" onClick={() => handleSaveAddMyDataToAll()} disabled={loadingApplyToAll}>
                                        Ναι, προσθήκη {loadingApplyToAll && <Spinner size={"sm"} animation="border" variant="dark"/>}
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => callbackFunction(obj)}>
                        Αποθήκευση
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default CategoryModal;
